<template>
  <div>
    <a-row :gutter="[12,8]" class="zjmp_t4">
      <a-col :span="24">
        <div class="item">
          <img src="@/assets/zjmp_icon1.svg">
          <span>抽取：</span>
          <strong>{{ expertFlagNumInfo.extractNum }}</strong>
        </div>
      </a-col>
      <a-col :span="8">
        <div class="item">
          <img src="@/assets/zjmp_icon2.svg">
          <span>参加：</span>
          <strong>{{ expertFlagNumInfo.attendNum }}</strong>
        </div>
      </a-col>
      <a-col :span="8">
        <div class="item">
          <img src="@/assets/zjmp_icon3.svg">
          <span>请假：</span>
          <strong>{{ expertFlagNumInfo.leaveNum }}</strong>
        </div>
      </a-col>
      <a-col :span="8">
        <div class="item">
          <img src="@/assets/zjmp_icon4.svg">
          <span>缺席：</span>
          <strong>{{ expertFlagNumInfo.absentNum }}</strong>
        </div>
      </a-col>
      <a-col :span="24">
        <div class="item">
          <img src="@/assets/zjmp_icon5.svg">
          <span>出席率：</span>
          <strong>{{ expertFlagNumInfo.attendRate }}%</strong>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>


export default {
  name: 'ExtractNumView',
  components: {},
  props: {
    expertFlagNumInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {}
  },
  created () {
  },
  methods: {}
}
</script>

<style></style>
